<template>
    <div id='app-vue'>
        <notifications group="main" :position="'bottom right'" width=500 :duration="5000" />
        <div
          id="reloadNotification"
          class="alert alert-warning text-center d-none"
          role="alert"
        >
          <i class="fa fa-exclamation-triangle" aria-hidden="true" />
          Une nouvelle version est disponible.. Merci de <a href="#" id="reloadSW" @click.prevent="reload">rafraichir la page</a>.
        </div>

        <Install></Install>
        <Header></Header>
        <router-view id="content-panel"/>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from './components/Header/Header.vue'
import Footer from './components/Footer/Footer.vue'
import Install from './components/Install/Install.vue';
import{
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';

    export default {
        components: {Header,Footer,Install},
        data() {
            return {}
        },
        computed: {},
        methods: {
            ...mapMutations([
                'setCart'
            ]),

            reload() {
              window.location.reload();
            },
        },
        mounted() {
            if (localStorage.getItem('cart')) {
                this.setCart(JSON.parse(localStorage.getItem('cart')));
            }
        },
    }
</script>

<style lang="scss" src="./../sass/style.scss"></style>
<style scoped>
    @media print {
        #content-panel {
            background-color: #ffffff;
        }
    }
    #content-panel {
        min-height: 49rem;
        font-family: 'Montserrat', sans-serif !important;
    }

</style>
